import { render, staticRenderFns } from "./LiveVideo.vue?vue&type=template&id=f535e83c&scoped=true&"
import script from "./LiveVideo.vue?vue&type=script&lang=js&"
export * from "./LiveVideo.vue?vue&type=script&lang=js&"
import style0 from "./LiveVideo.vue?vue&type=style&index=0&id=f535e83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f535e83c",
  null
  
)

export default component.exports